import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../dashboard/useAuth';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import Select from "react-select";
import axios from 'axios';
import { getAuthToken } from '../../authToken';

const ActivationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user_id = localStorage.getItem('user_id');
  const { user, titre } = location.state || {};
  const [value, setValue] = useState();

  const TextAvecVoirPlus = () => {
    const [voirPlus, setVoirPlus] = useState(false);

    const texteComplet = `Dans le cadre de ses prestations, INOVACT procède au traitement de données personnelles intéressant 
  le Client ainsi que des participants aux sessions de formations tels que figurant dans le bulletin d’inscription. 
  En tout état de cause INOVACT ne collecte des informations personnelles relatives à l’utilisateur que pour le 
  besoin des services proposés. L’utilisateur fournit ces informations en toute connaissance de cause, 
  notamment lorsqu’il procède par lui-même à leur saisie. Conformément aux dispositions de la loi 2017-20 portant 
  code du numérique en République du Bénin, tout utilisateur dispose d’un droit d’accès, de rectification et d’opposition 
  aux données personnelles le concernant, en effectuant sa demande écrite et signée, accompagnée d’une copie du titre 
  d’identité avec signature du titulaire de la pièce, en précisant l’adresse à laquelle la réponse doit être envoyée. 
  Aucune information personalisée de l'utilisateur n'est publiée à l'insu de l'utilisateur, échangée, transférée, 
  cédée ou vendue sur un support quelconque à des tiers. Les données à caractère personnel collectées seront traitées 
  exclusivement à des fins d'exécution des présentes conditions de vente et également en vue d'actions commerciales, 
  afin de proposer au Client ou aux participants qui y consentent des services analogues à ceux objets du présent 
  contrat par INOVACT. Les données à caractère personnel collectées peuvent être communiquées à des tiers auxquels 
  il serait nécessaire de les transmettre en exécution des prestations convenues et notamment aux organismes de financement, 
  afin de permettre la prise en charge des formations objets des présentes. Conformément à la loi précitée, 
  vous pouvez exercer vos droits d'accès, d'opposition, de rectification et de suppression auprès de la direction de INOVACT.`;

    const texteAbrege = `Dans le cadre de ses prestations, INOVACT procède au traitement de données personnelles intéressant 
  le Client ainsi que des participants aux sessions de formations. Conformément à la loi 2017-20 portant code du numérique 
  en République du Bénin, tout utilisateur dispose d'un droit d'accès, de rectification et d'opposition aux données 
  personnelles le concernant...`;

    return (
      <div className="text-justify mb-3">
        <small>
          {voirPlus ? texteComplet : texteAbrege}
          <button
            type="button"
            className="btn btn-link p-0 ml-1"
            onClick={() => setVoirPlus(!voirPlus)}
            style={{
              fontSize: 'inherit',
              textDecoration: 'underline',
              border: 'none',
              background: 'none',
              color: '#007bff',
              cursor: 'pointer'
            }}
          >
            {voirPlus ? 'Voir moins' : 'Voir plus'}
          </button>
        </small>
      </div>
    );
  };

  const fetchUtilisateur = async () => {
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });

      const data = await response.json();
      setFormData(data);
    } catch (error) {
      console.error('Erreur lors de la récupération des données utilisateur', error);
    }
  };

  useEffect(() => {
    if (user_id) {
      fetchUtilisateur();
    }
  }, [user_id]);

  const [formData, setFormData] = useState({
    nom: user?.family_name || '',
    prenoms: user?.given_name || '',
    email: user?.email || '',
    tel: '',
    profession: '',
    diplome: '',
    formation: [],
    sexe: '',
    civilite: '',
    type_profil: 'Apprenant',
    type_financement: 'Particulier',
    code_promo: '',
    code_partenaire: '',
    nom_organisation: '',
    email_corporate: ''
  });

  const [messages, setMessages] = useState([]);
  const [passwordConditions, setPasswordConditions] = useState({
    minLength: false,
    hasUppercase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });

  useEffect(() => {
    setFormData({
      nom: user?.family_name || '',
      prenoms: user?.given_name || '',
      email: user?.email || '',
      tel: '',
      profession: '',
      diplome: '',
      formation: [],
      sexe: '',
      civilite: '',
      type_profil: '',
      type_financement: '',
      code_promo: '',
      code_partenaire: '',
      nom_organisation: '',
      email_corporate: ''
    });
  }, [user, user_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === 'mdp1') {
      checkPasswordStrength(value);
    }
  };

  const checkPasswordStrength = (password) => {
    setPasswordConditions({
      minLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const [produits, setProduits] = useState([]);
  const fetchProduits = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + '/liste-produit/');
      if (response.ok) {
        const data = await response.json();
        setProduits(data);
      } else {
        console.error('Erreur lors de la récupération des produits');
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
    }
  };

  const [formation, setFormation] = useState([]);

  const parseFormationDate = (dateString) => {
    if (!dateString) return new Date();

    try {
      if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return new Date(dateString);
      }

      if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        const [day, month, year] = dateString.split('/');
        return new Date(year, month - 1, day);
      }

      return new Date(dateString);
    } catch (error) {
      console.warn(`Erreur de parsing de date: ${dateString}`, error);
      return new Date();
    }
  };

  const fetchFormation = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + '/liste-formation/');
      if (response.ok) {
        const data = await response.json();

        const formationActive = data.filter(formation => {
          if (formation.statut !== "actif") return false;

          if (formation.date) {
            const formationDate = parseFormationDate(formation.date);
            formationDate.setHours(0, 0, 0, 0);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return formationDate >= today;
          }

          return true;
        });

        setFormation(formationActive);
      } else {
        console.error('Erreur lors de la récupération des formations');
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
    }
  };

  useEffect(() => {
    fetchFormation();
    fetchProduits();
  }, []);

  const isValidDate = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date);
  };

  const normalizeDate = (dateString) => {
    if (!dateString) return null;

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    const date = new Date(dateString);
    if (isValidDate(date)) {
      return date.toISOString().split('T')[0];
    }

    return null;
  };

  const isDateList = (periode) => {
    if (!periode) return false;

    if (typeof periode === 'string') {
      try {
        const cleanedPeriode = periode.replace(/'/g, '"');
        const parsed = JSON.parse(cleanedPeriode);
        return Array.isArray(parsed) && parsed.length > 0;
      } catch (error) {
        return false;
      }
    }

    return Array.isArray(periode) && periode.length > 0;
  };

  const formatFormationPeriod = (periode) => {
    if (!periode || periode === '[]' || periode === '""' || periode === "''") {
      return "À la demande";
    }

    if (isDateList(periode)) {
      try {
        let dates;
        if (typeof periode === 'string') {
          const cleanedPeriode = periode.replace(/'/g, '"');
          dates = JSON.parse(cleanedPeriode);
        } else {
          dates = periode;
        }

        const validDates = dates
          .map(date => normalizeDate(date))
          .filter(date => date !== null && isValidDate(new Date(date)))
          .sort();

        if (validDates.length > 0) {
          // Retourner une chaîne de caractères au lieu de JSX
          return validDates.map((date, index) => {
            const dateObj = new Date(date);
            return dateObj.toLocaleDateString('fr-FR', {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit'
            });
          }).join(', ');
        }
      } catch (error) {
        console.warn('Erreur de parsing des dates:', error);
      }
    }

    if (typeof periode === 'string' && periode.trim() !== '') {
      return periode;
    }

    return '-';
  };


  const getFormationLabel = (formation) => {
    const baseLabel = formation.nom;
    const periodLabel = formatFormationPeriod(formation.periode);

    // NOUVELLE LOGIQUE : Choisir le prix en fonction du type de financement
    const prix = formData.type_financement === 'Particulier' && formation.prix_particulier > 0
      ? formation.prix_particulier
      : formation.prix;

    const priceLabel = prix ? `${prix.toLocaleString()} FCFA` : '';

    return `${baseLabel} (${periodLabel}) ${priceLabel ? `- ${priceLabel}` : ''}`;
  };

  const options = [
    ...formation.map((formation) => ({
      value: formation.reference,
      label: getFormationLabel(formation),
      formation: formation
    })),
    ...produits.map((produit) => ({
      value: produit.id,
      label: `${produit.nom} - ${produit.prix ? `${produit.prix.toLocaleString()} FCFA` : ''}`,
      produit: produit
    })),
    { value: 'Autre_Service', label: 'Autre Service' },
  ];


  const isOnlyFormationsSelected = () => {
    // S'assurer que formData.formation est un tableau
    const formations = Array.isArray(formData.formation) ? formData.formation : [];

    if (formations.length === 0) return false;

    return formations.every(item => {
      // Vérifier si c'est une formation (contient "FORM" dans la référence ou l'ID)
      if (typeof item === 'string') {
        return item.includes('FORM') || formation.some(f => f.reference === item);
      }
      return false;
    });
  };

  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)

    try {
      let response = ''
      if (formData?.type_profil === 'Apprenant') {
        response = await fetch(process.env.REACT_APP_HOTE + `/activer-compte/${user_id}/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
      } else {
        const dataToSend = {
          ...formData,
          user_id,
        };

        response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-partenaire/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(dataToSend),
        });
      }

      const result = await response.json();

      if (response.ok) {
        showAlert('Activation réussie !');
        navigate(`/dashboard`);
        // if (formData.type_profil === "Apprenant") {
        //   navigate(`/Souscription-utilisateur`, { state: { user, titre } });
        // } else {
        //   navigate(`/dashboard`);
        // }
      } else {
        showAlert(result.error, 'danger');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessages(['Erreur de connexion au serveur.']);
    } finally {
      setLoading(false)
    }
  };

  const handleRetour = () => {
    navigate(`/`);
  };

  const pageStyle = {
    backgroundColor: '#f5f7fa',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  };

  const messageStyle = {
    textAlign: 'left',
    marginBottom: '8px',
    marginTop: '8px',
  };

  const getConditionClass = (condition) => condition ? 'text-success' : 'text-default';

  const [phoneError, setPhoneError] = useState('');

  const handlePhoneChange = (value) => {
    if (value && !value.startsWith('+')) {
      setPhoneError('Le numéro doit commencer par un indicatif pays (ex: +229)');
    } else {
      setPhoneError('');
      setFormData({
        ...formData,
        tel: value,
      });
    }
  };

  const [alert, setAlert] = useState({ message: '', type: '' });
  const showAlert = (message, type = 'success') => {
    setAlert({ message, type });
  };

  return (
    <div style={pageStyle}>
      <div className="container d-flex flex-column justify-content-center min-vh-100 py-4">
        <div className="row justify-content-center flex-grow-1">
          <div className="col-md-10 col-lg-8 d-flex flex-column">
            <div className="text-center loginscreen animated fadeInDown flex-grow-1 d-flex flex-column justify-content-center">
              <div className="ibox-content p-4 rounded">
                <div className="mb-4">
                  <i className="fa fa-user-circle login-logo" style={{ fontSize: '50px' }}></i>
                </div>
                <h3 className="font-bold">Complétez votre profil</h3>
                <p className="text-muted">Veuillez entrer vos informations</p>

                {alert.message && (
                  <div className={`alert alert-${alert.type} row justify-content-between position-relative m-1`}>
                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                  </div>
                )}

                {phoneError && <div className="text-danger small">{phoneError}</div>}

                <form className="m-t" role="form">
                  {/* Ligne 1 - 3 champs */}
                  <div className="form-row">
                    <div className="form-group text-left col-md-4">
                      <label>Civilité <span className="text-danger">*</span></label>
                      <select
                        className="form-control"
                        required
                        name="civilite"
                        value={formData.civilite}
                        onChange={handleChange}
                      >
                        <option value="">Sélectionnez</option>
                        <option value="Monsieur">Monsieur</option>
                        <option value="Madame">Madame</option>
                        <option value="Mademoiselle">Mademoiselle</option>
                      </select>
                    </div>
                    <div className="form-group text-left col-md-4">
                      <label>Nom <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Nom"
                        required
                        name="nom"
                        value={formData.nom}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group text-left col-md-4">
                      <label>Prénom(s) <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Prénom"
                        required
                        name="prenoms"
                        value={formData.prenoms}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Ligne 2 - 3 champs */}
                  <div className="form-row">
                    <div className="form-group text-left col-md-4">
                      <label>Email <span className="text-danger">*</span></label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group text-left col-md-4">
                      <label>Téléphone <span className="text-danger">*</span></label>
                      <PhoneInput
                        international
                        defaultCountry="BJ"
                        value={formData.tel}
                        onChange={handlePhoneChange}
                        inputStyle={{ width: '100%' }}
                        containerStyle={{ width: '100%' }}
                        required
                        inputProps={{
                          name: 'tel',
                          required: true,
                        }}
                        dropdownStyle={{
                          maxHeight: '200px',
                          overflowY: 'auto',
                          zIndex: 1050,
                        }}
                      />
                    </div>
                    <div className="form-group text-left col-md-4">
                      <label>Type de profil <span className="text-danger">*</span></label>
                      <select
                        className="form-control"
                        required
                        name="type_profil"
                        value={formData.type_profil}
                        onChange={handleChange}
                      >
                        <option value="">Sélectionnez</option>
                        <option value="Apprenant">Apprenant</option>
                        {/* <option value="Partenaire">Partenaire</option> */}
                      </select>
                    </div>
                  </div>

                  {/* Ligne 3 - 3 champs */}

                  {formData.type_profil === "Apprenant" &&
                    <div className="form-row">
                      <div className="form-group text-left col-md-4">
                        <label>Type de financement <span className="text-danger">*</span></label>
                        <select
                          className="form-control"
                          required
                          name="type_financement"
                          value={formData.type_financement}
                          onChange={handleChange}
                        >
                          <option value="">Choisir type de financement</option>
                          <option value="Particulier">Particulier</option>
                          <option value="Entreprise">Entreprise</option>
                          <option value="Partenariat">Partenariat</option>
                        </select>
                      </div>
                      <div className="form-group text-left col-md-4">
                        <label>Profession <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Profession"
                          required
                          name="profession"
                          value={formData.profession}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-group text-left col-md-4">
                        <label>Diplôme <span className="text-danger">*</span></label>
                        <select
                          className="form-control"
                          required
                          name="diplome"
                          value={formData.diplome}
                          onChange={handleChange}
                        >
                          <option value="">Diplôme le plus élevé</option>
                          <option value="BAC">BAC</option>
                          <option value="BTS">BTS</option>
                          <option value="Licence">Licence</option>
                          <option value="Master1">Master1</option>
                          <option value="Master2">Master2</option>
                          <option value="Doctorat">Doctorat</option>
                          <option value="Ingénieur">Ingénieur</option>
                          <option value="Autres">Autres</option>
                        </select>
                      </div>
                    </div>
                  }

                  {/* Ligne 4 - 2 champs */}
                  {/* <div className="form-row">
                    <div className="form-group text-left col-md-4">
                      <label>Sexe <span className="text-danger">*</span></label>
                      <select
                        className="form-control"
                        required
                        name="sexe"
                        value={formData.sexe}
                        onChange={handleChange}
                      >
                        <option value="">Sélectionnez le sexe</option>
                        <option value="Masculin">Masculin</option>
                        <option value="Féminin">Féminin</option>
                      </select>
                    </div>
                  </div> */}

                  {/* Champs organisation pour partenaire */}
                  <div className="form-row">
                    <div className="form-group text-left col-md-6">
                      <label>Nom de l'organisation</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Nom de l'organisation"
                        required
                        name="nom_organisation"
                        value={formData.nom_organisation}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group text-left col-md-6">
                      <label>Email de l'organisation</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email de l'organisation"
                        required
                        name="email_corporate"
                        value={formData.email_corporate}
                        onChange={handleChange}
                      />
                    </div>
                  </div>


                  {formData.type_profil === "Apprenant" &&
                    <>
                      {/* Formation & Produits disponibles */}
                      {/* <div className="form-row">
                        <div className="form-group text-left col-md-12">
                          <label>Formations & services <span className="text-danger">*</span></label>
                          <Select
                            options={options}
                            isMulti
                            value={options.filter(option => formData.formation.includes(option.value))}
                            onChange={(selectedOptions) =>
                              setFormData({ ...formData, formation: selectedOptions.map(option => option.value) })
                            }
                            placeholder="Formations et services"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            required
                          />
                        </div>
                      </div> */}

                      {/* Codes promo et partenaire */}

                      {/* <div className="form-row">
                        <div className="form-group text-left col-md-6">
                          <label>Code promo</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Code promo"
                            name="code_promo"
                            value={formData.code_promo}
                            onChange={handleChange}
                            disabled={formData.type_financement !== 'Particulier' || !isOnlyFormationsSelected()}
                            style={{
                              backgroundColor: (formData.type_financement !== 'Particulier' || !isOnlyFormationsSelected()) ? '#f8f9fa' : '',
                              color: (formData.type_financement !== 'Particulier' || !isOnlyFormationsSelected()) ? '#6c757d' : '',
                              cursor: (formData.type_financement !== 'Particulier' || !isOnlyFormationsSelected()) ? 'not-allowed' : ''
                            }}
                          />
                          {!isOnlyFormationsSelected() && formData.formation && formData.formation.length > 0 && (
                            <Form.Text className="text-muted">
                              Les codes ne s'appliquent qu'aux formations
                            </Form.Text>
                          )}
                        </div>
                        <div className="form-group text-left col-md-6">
                          <label>Code partenaire</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Code partenaire"
                            name="code_partenaire"
                            value={formData.code_partenaire}
                            onChange={handleChange}
                            disabled={formData.type_financement !== 'Particulier' || !isOnlyFormationsSelected()}
                            style={{
                              backgroundColor: (formData.type_financement !== 'Particulier' || !isOnlyFormationsSelected()) ? '#f8f9fa' : '',
                              color: (formData.type_financement !== 'Particulier' || !isOnlyFormationsSelected()) ? '#6c757d' : '',
                              cursor: (formData.type_financement !== 'Particulier' || !isOnlyFormationsSelected()) ? 'not-allowed' : ''
                            }}
                          />
                          {!isOnlyFormationsSelected() && formData.formation && formData.formation.length > 0 && (
                            <Form.Text className="text-muted">
                              Les codes ne s'appliquent qu'aux formations
                            </Form.Text>
                          )}
                        </div>
                      </div> */}
                    </>
                  }

                  {/* <TextAvecVoirPlus /> */}
                  <div className='text-left mb-2 ml-1'>
                    <a className='text-left text-success' style={{
                      textDecoration: 'underline',
                      textDecorationColor: '#1c09ecff',
                      transition: 'all 0.3s ease'
                    }}
                      href='https://inovact.com/politique-confidentialite.html'
                      onMouseEnter={(e) => e.target.style.textDecoration = 'underline dotted'}
                      onMouseLeave={(e) => e.target.style.textDecoration = 'underline'}>
                      Politique de confidentialité
                    </a>
                  </div>

                  <div className='d-flex justify-content-between'>
                    <button
                      onClick={handleRetour}
                      disabled={loading}
                      type="button"
                      className="btn btn-secondary block full-width m-1"
                    >
                      Retour
                    </button>
                    <button
                      onClick={handleSubmit}
                      disabled={loading}
                      type="submit"
                      className="btn btn-success block full-width m-1"
                    >
                      {loading ? 'Enregistrement...' : 'Enregistrer'}
                    </button>
                  </div>
                </form>
              </div>
              <div
                className="ibox-footer full-w mt-2 d-flex align-items-center justify-content-between pl-3 pr-3"
                style={{
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                <small>© {new Date().getFullYear()} <strong>Inovact</strong>. Tous droits réservés.</small>
                <div className="d-flex align-items-center justify-content-between">
                  <small className="me-3 text-muted mr-2">Nous suivre</small>
                  <div className="d-flex align-items-center gap-3">
                    <a href="https://www.facebook.com/inovact/" className="text-decoration-none social-icon d-flex align-items-center justify-content-center mr-2"
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: '#4c4d4e10',
                        border: '1px solid #4c4d4e10',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#6c757d';
                        e.currentTarget.style.borderColor = '#6c757d';
                        e.currentTarget.querySelector('i').style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#4c4d4e10';
                        e.currentTarget.style.borderColor = '#4c4d4e10';
                        e.currentTarget.querySelector('i').style.color = '#6c757d';
                      }}
                      title="Facebook">
                      <i className="fa fa-facebook-f" style={{ fontSize: '12px', color: '#6c757d', transition: 'color 0.3s ease' }}></i>
                    </a>
                    <a href="https://x.com/Inovact_Sarl" className="text-decoration-none social-icon d-flex align-items-center justify-content-center mr-2"
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: '#4c4d4e10',
                        border: '1px solid #4c4d4e10',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#6c757d';
                        e.currentTarget.style.borderColor = '#6c757d';
                        e.currentTarget.querySelector('i').style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#4c4d4e10';
                        e.currentTarget.style.borderColor = '#4c4d4e10';
                        e.currentTarget.querySelector('i').style.color = '#6c757d';
                      }}
                      title="Twitter">
                      <i className="fa fa-twitter" style={{ fontSize: '12px', color: '#6c757d', transition: 'color 0.3s ease' }}></i>
                    </a>
                    <a href="https://www.linkedin.com/company/inovact" className="text-decoration-none social-icon d-flex align-items-center justify-content-center mr-2"
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: '#4c4d4e10',
                        border: '1px solid #4c4d4e10',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#6c757d';
                        e.currentTarget.style.borderColor = '#6c757d';
                        e.currentTarget.querySelector('i').style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#4c4d4e10';
                        e.currentTarget.style.borderColor = '#4c4d4e10';
                        e.currentTarget.querySelector('i').style.color = '#6c757d';
                      }}
                      title="LinkedIn">
                      <i className="fa fa-linkedin" style={{ fontSize: '12px', color: '#6c757d', transition: 'color 0.3s ease' }}></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivationPage;